import _ from 'underscore';

import {GAP} from 'biojs/BioConstants';

export function calculateLength(residues: string, trimStart: number, trimEnd: number): number {
  return Array.from(residues.slice(trimStart, trimEnd)).filter((c) => c !== GAP).length;
}

export function calculateNumMismatches(
  residues: string,
  templateResidues: string,
  trimStart: number,
  trimEnd: number
): number {
  // When editing the template row, this will be called first with updated residues and trimEnd but stale
  // templateResidues. We want to avoid an error in this case; it doesn't matter that the mismatch count
  // is temporarily underestimated, since this func will be called again when the template save completes.
  const effectiveTrimEnd = Math.min(trimEnd, residues.length, templateResidues.length);
  const trimmedChars = Array.from(residues.slice(trimStart, effectiveTrimEnd));
  const templateChars = Array.from(templateResidues.slice(trimStart, effectiveTrimEnd));
  return _.zip(trimmedChars, templateChars).reduce(
    (mismatchCount: number, charsAtIdx: [string, string]) =>
      charsAtIdx[0].toLowerCase() === charsAtIdx[1].toLowerCase() ? mismatchCount : mismatchCount + 1,
    0
  );
}

// Note: This function mirrors the functionality implemented in the back-end at
// benchling/dev_platform/resources/sequence_alignments.py. Make sure to change that file if you decide
// to change this algorithm!
export function calculatePairwiseIdentity(
  residues: string,
  templateResidues: string,
  trimStart: number,
  trimEnd: number
): number {
  const effectiveTrimEnd = Math.min(trimEnd, residues.length, templateResidues.length);
  const length = effectiveTrimEnd - trimStart;
  if (length <= 0) {
    return 0;
  }
  const numMatches = length - calculateNumMismatches(residues, templateResidues, trimStart, trimEnd);
  return numMatches / length;
}
